/* global ga */

export const getTagsFromPath = (pathname) => {
  return pathname.split('/').filter(tag => tag && tag !== 'questions' && tag !== 'results');
};

export const track = (eventCategory, eventLabel, eventAction = 'click') => {
  // console.log('track', eventCategory, eventLabel, eventAction);
  ga('send', 'event', eventCategory, eventAction, eventLabel);
};



// WEBPACK FOOTER //
// ./src/helpers.js